import { Grid } from '@material-ui/core'
import { AppLayout } from 'components/facets'
import { useAppContext } from 'lib/hooks'
import { DashboardPresenter } from '../domain/dashboard'

export const Dashboard = (): JSX.Element => {
  const { isMobile } = useAppContext()
  // const [showTutorials, setShowTutorials] = useState<boolean>(false)

  return (
    <AppLayout>
      <Grid
        container
        className="dashboard w-100"
        style={{ minHeight: isMobile ? 'calc(100vh - 50px)' : '100vh' }}
      >
        <DashboardPresenter />
      </Grid>
    </AppLayout>
  )
}
